export default function roundPvalue(val) {
  if (val) {
    if (val < 0.001) return "<.001";
    else return val.toFixed(3);
  }
}
